import styled, { keyframes } from 'styled-components';
import { motion } from 'framer-motion';
import { min } from '../../../theme/breakpoints';

const backgroundAnimation = keyframes`
  0% {
    transform: translateY(0px);
  }
  100% {
    transform: translateY(-440px);
  }
`;

export const SubscribeToContainer = styled(motion.div)`
  overflow: hidden;
  text-align: center;
  background-color: ${({ theme }) => theme.colors.RipeLemon};
  position: relative;

  .bg-subscribe {
    max-width: none;
    position: absolute;
    width: 100%;
    height: 880px;
    top: 0;
    left: 0;
    animation: ${backgroundAnimation} 30s infinite linear;
    z-index: 1;
  }
  .section-wrapper {
    height: 300px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: relative;
    z-index: 2;

    @media screen and ${min('tablet')} {
      height: 320px;
    }
    @media screen and ${min('largeTablet')} {
      height: 430px;
    }
    a:focus-visible {
      background-color: ${({ theme }) => theme.colors['Black']} !important;
      outline: 2px solid ${({ theme }) => theme.colors['Black']} !important;
      color: ${({ theme }) => theme.colors['RipeLemon']} !important;
    }
  }
`;

export const SubscribeToTitle = styled.h2`
  color: ${({ theme }) => theme.colors.Black};
  font-family: ${({ theme }) => theme.fonts.secondary.bold};
  text-transform: uppercase;
  font-size: 1.75rem;
  margin-bottom: 1.875rem;

  @media screen and ${min('largeTablet')} {
    font-size: 3rem;
  }
`;
